/* ==========================================================================
   MARECLO V4 — v4-favorites.js   (23.09.2026, Favoriten)

   Kalp butonlarının ([data-fav], snippets/v4-favorite-button.liquid) davranışı.
   Tek dosya, bağımlılık yok; layout/theme.liquid'den defer ile bir kez yüklenir.

   Akış
     - Oturum açık:  sayfa açılınca GET /apps/club/favorites (5 dk sessionStorage
                     önbelleği), eşleşen kalpler is-active + aria-pressed=true.
                     Tıklama: iyimser toggle → POST {action:"toggle"} → hata olursa
                     geri al. Küçük toast: "Zu deinen Favoriten hinzugefügt".
     - Oturum kapalı: modal yok, doğrudan giriş sayfası (Douglas deseni):
                     /customer_authentication/login?return_to=<bu sayfa>&fav=<id>&favh=<handle>
                     Girişten dönünce URL'deki fav= okunur, POST {action:"add"},
                     kalp işaretlenir, toast gösterilir, parametreler replaceState
                     ile temizlenir.

   Backend: tools/loyalty (app proxy). Müşteri kimliği temadan ASLA gönderilmez;
   proxy oturumdan kendi çözer. window.mareclo.{customerLoggedIn, favoritesText}
   theme.liquid'de basılır.
   ========================================================================== */
(function () {
  "use strict";

  var API = "/apps/club/favorites";
  var LOGIN = "/customer_authentication/login";
  var CACHE_KEY = "mareclo:favorites";
  var CACHE_TTL = 5 * 60 * 1000; /* 5 dk */
  var TOAST_MS = 2200;

  var cfg = window.mareclo || {};
  var text = cfg.favoritesText || {};
  var loggedIn = cfg.customerLoggedIn === true;
  var favIds = null; /* Set<string> — yalnızca oturum açıkken dolu */
  var pending = {}; /* productId → true (istek uçarken çift tıklamayı yut) */

  /* ---------------------------------------------------------------- yardımcılar */
  function hearts(productId) {
    var sel = productId ? '[data-fav][data-fav-product-id="' + productId + '"]' : "[data-fav]";
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function setState(btn, active) {
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var label = active ? text.remove : text.add;
    if (label) btn.setAttribute("aria-label", label);
  }

  function paint(productId, active) {
    hearts(productId).forEach(function (btn) { setState(btn, active); });
  }

  function paintAll() {
    if (!favIds) return;
    hearts().forEach(function (btn) {
      setState(btn, favIds.has(String(btn.getAttribute("data-fav-product-id"))));
    });
  }

  /* -- önbellek: id listesi 5 dk sessionStorage'da; her sayfada istek atılmaz -- */
  function readCache() {
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.ids) || Date.now() - data.t > CACHE_TTL) return null;
      return new Set(data.ids.map(String));
    } catch (e) { return null; }
  }

  function writeCache(set) {
    try {
      window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), ids: Array.from(set) }));
    } catch (e) { /* private mode / dolu depo — sessiz geç */ }
  }

  function clearCache() {
    try { window.sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
  }

  /* ------------------------------------------------------------------ toast */
  var toastEl = null;
  var toastTimer = 0;
  function toast(message, kind) {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "v4-toast";
      toastEl.setAttribute("role", "status");
      toastEl.setAttribute("aria-live", "polite");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.toggle("v4-toast--error", kind === "error");
    /* Animasyon her seferinde baştan oynasın. */
    toastEl.classList.remove("is-visible");
    void toastEl.offsetWidth;
    toastEl.classList.add("is-visible");
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toastEl.classList.remove("is-visible"); }, TOAST_MS);
  }

  /* -------------------------------------------------------------------- API */
  function request(method, body) {
    var init = { method: method, credentials: "same-origin", headers: { Accept: "application/json" } };
    if (body) {
      init.headers["Content-Type"] = "application/json";
      init.body = JSON.stringify(body);
    }
    return window.fetch(API, init).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (res.status === 401 || (data && data.error === "login_required")) {
          var err = new Error("login_required"); err.loginRequired = true; throw err;
        }
        if (!res.ok || !data || data.ok !== true) throw new Error((data && data.error) || ("http_" + res.status));
        return data;
      });
    });
  }

  function loadFavorites() {
    var cached = readCache();
    if (cached) { favIds = cached; paintAll(); return Promise.resolve(favIds); }
    return request("GET").then(function (data) {
      favIds = new Set((data.items || []).map(function (it) { return String(it.productId); }));
      writeCache(favIds);
      paintAll();
      return favIds;
    }).catch(function (err) {
      /* 401: Liquid "customer" var ama proxy oturumu görmedi — kalpler pasif kalır,
         tıklama yine giriş sayfasına gider. Diğer hatalar sessiz (kalp pasif). */
      if (err && err.loginRequired) { loggedIn = false; clearCache(); }
      favIds = favIds || new Set();
      return favIds;
    });
  }

  /* -------------------------------------------------------- oturum kapalı */
  var PENDING_KEY = "mareclo:favPending";

  function goToLogin(productId, handle) {
    /* Giray 23.09: MARECLO tasarımlı giriş paneli (snippets/v4-login-drawer) varsa onu
       açarız; panel e-postayı alır, Shopify'ın kod ekranına geçer ve return_to ile buraya
       döner, bekleyen ürün otomatik eklenir. Panel yoksa doğrudan giriş sayfası. */
    var drawer = window.mareclo && window.mareclo.loginDrawer;
    if (drawer) { drawer.open({ productId: productId, handle: handle || "" }); return; }
    var here = window.location.pathname + window.location.search;
    var sep = window.location.search ? "&" : "?";
    var back = here + sep + "fav=" + encodeURIComponent(productId) + "&favh=" + encodeURIComponent(handle || "");
    window.location.href = LOGIN + "?return_to=" + encodeURIComponent(back);
  }

  /* Panel içi giriş sayfayı yenilemeyebilir: bekleyen favori varken 5 dk boyunca 3 sn'de
     bir proxy'ye sorarız; 200 dönünce oturum açılmış demektir → ekle, kalbi doldur, not göster. */
  var signInWatcher = null;
  function watchForSignIn() {
    if (signInWatcher) return;
    var started = Date.now();
    signInWatcher = window.setInterval(function () {
      if (Date.now() - started > 5 * 60 * 1000) { window.clearInterval(signInWatcher); signInWatcher = null; return; }
      request("GET").then(function (data) {
        window.clearInterval(signInWatcher); signInWatcher = null;
        loggedIn = true;
        favIds = new Set((data.items || []).map(function (it) { return String(it.productId); }));
        writeCache(favIds);
        paintAll();
        applyPending();
      }).catch(function () {});
    }, 3000);
  }

  function applyPending() {
    var raw = null;
    try { raw = sessionStorage.getItem(PENDING_KEY); } catch (e) {}
    if (!raw) return;
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
    var p; try { p = JSON.parse(raw); } catch (e) { return; }
    if (!p || !p.productId || Date.now() - (p.t || 0) > 30 * 60 * 1000) return;
    if (favIds && favIds.has(String(p.productId))) { paint(String(p.productId), true); return; }
    request("POST", { productId: String(p.productId), handle: p.handle || "", action: "add" }).then(function (data) {
      if (!favIds) favIds = new Set();
      favIds.add(String(p.productId)); writeCache(favIds); paint(String(p.productId), true);
      toast(text.added || "");
    }).catch(function () {});
  }

  /* --------------------------------------------------------------- toggle */
  function toggle(productId, handle) {
    if (pending[productId]) return;
    var was = !!(favIds && favIds.has(productId));
    var next = !was;
    pending[productId] = true;
    paint(productId, next); /* iyimser */
    if (!favIds) favIds = new Set();
    if (next) favIds.add(productId); else favIds.delete(productId);

    request("POST", { productId: productId, handle: handle, action: "toggle" }).then(function (data) {
      var fav = typeof data.favorited === "boolean" ? data.favorited : next;
      if (fav) favIds.add(productId); else favIds.delete(productId);
      paint(productId, fav);
      writeCache(favIds);
      toast(fav ? text.added : text.removed);
    }).catch(function (err) {
      /* geri al */
      if (was) favIds.add(productId); else favIds.delete(productId);
      paint(productId, was);
      if (err && err.loginRequired) { loggedIn = false; clearCache(); goToLogin(productId, handle); return; }
      toast(text.error, "error");
    }).then(function () { delete pending[productId]; });
  }

  /* ---------------------------------------- girişten dönüş: ?fav=…&favh=… */
  function consumeReturnParams() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var productId = params.get("fav");
    var handle = params.get("favh") || "";
    if (!productId) return;

    params.delete("fav");
    params.delete("favh");
    var clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
    try { window.history.replaceState(window.history.state, "", clean); } catch (e) {}

    if (!loggedIn) return; /* girişten vazgeçilmiş — sessizce temizle */
    if (!/^\d+$/.test(productId)) return;

    if (favIds && favIds.has(productId)) { paint(productId, true); return; }
    pending[productId] = true;
    paint(productId, true);
    request("POST", { productId: productId, handle: handle, action: "add" }).then(function (data) {
      var fav = data.favorited !== false;
      if (!favIds) favIds = new Set();
      if (fav) favIds.add(productId);
      paint(productId, fav);
      writeCache(favIds);
      toast(text.added);
    }).catch(function () {
      paint(productId, false);
      toast(text.error, "error");
    }).then(function () { delete pending[productId]; });
  }

  /* -------------------------------------------------------------- click */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest("[data-fav]");
    if (!btn) return;
    /* Kart linki / "+ Warenkorb" handler'ı bu tıklamayı asla görmesin. */
    event.preventDefault();
    event.stopPropagation();
    var productId = String(btn.getAttribute("data-fav-product-id") || "");
    var handle = btn.getAttribute("data-fav-handle") || "";
    if (!productId) return;
    if (!loggedIn) { goToLogin(productId, handle); return; }
    toggle(productId, handle);
  }, true); /* capture: theme.js'in delegated card handler'ından önce */

  /* Sonradan eklenen kartlar (ör. bir bölümün fetch ile yenilenmesi) da boyansın. */
  if (window.MutationObserver) {
    var raf = 0;
    new MutationObserver(function () {
      if (!favIds || raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; paintAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------------- init */
  function init() {
    if (loggedIn) {
      loadFavorites().then(consumeReturnParams).then(applyPending); /* panel girişinden sonra yeniden yüklendiyse */
    } else {
      consumeReturnParams(); /* sadece URL'yi temizler */
    }
  }

  /* Test/hata ayıklama için küçük yüzey: window.mareclo.favorites.refresh() */
  window.mareclo = window.mareclo || {};
  window.mareclo.favorites = {
    refresh: function () { clearCache(); favIds = null; return loggedIn ? loadFavorites() : Promise.resolve(null); },
    has: function (id) { return !!(favIds && favIds.has(String(id))); },
    toast: toast
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
